function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOutlink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "icon_outlink"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1018",
  style: {
    stroke: "#c4c4c4",
    strokeWidth: "1.3px",
    fill: "none"
  }
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h10v10H0z",
  style: {
    stroke: "none"
  },
  transform: "translate(2 2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.65.65h8.7v8.7H.65z",
  style: {
    fill: "none"
  },
  transform: "translate(2 2)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Subtraction 28",
  style: {
    fill: "#fff"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M15552 3690h-10v-1h9v-9h1z",
  style: {
    stroke: "none"
  },
  transform: "translate(-15537.501 -3675.5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15552.001 3689.999h-10V3689h9.001v-9h.999z",
  style: {
    fill: "#c4c4c4",
    stroke: "none"
  },
  transform: "translate(-15537.501 -3675.5)"
}))));
export default SvgIconOutlink;